import axios from "axios";
export async function getMaturities() {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/maturities");
    return response.data;
}
export async function getCoverages() {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/coverages");
    return response.data;
}

export async function setApplicable(control: number, applicable: boolean, notes?: string) {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/applicable/"+control, {
        applicable: applicable ? 1 : 0, 
        notes: notes
    });
    return response.data;
}

export async function getAISuggestions(controlText: string) {
    let response = await axios.post("http://localhost:9000",{question:controlText});
    return response.data;
}